import { Spinner, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { FC, PropsWithChildren } from 'react';
interface Props {
    isLoading: boolean;
}
const useStyles = makeStyles({
    spinnerOverlay: {
        position: 'relative',
    },
    content: {
        ...shorthands.transition('opacity', '0.3s', 'ease-in-out'),
    },
    spinner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    loading: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
});
const SpinnerOverlay: FC<PropsWithChildren<Props>> = ({ isLoading, children }) => {
    const classes = useStyles();
    return (
        <div className={classes.spinnerOverlay}>
            {isLoading && (
                <div className={classes.spinner}>
                    <Spinner />
                </div>
            )}
            <div className={mergeClasses(classes.content, isLoading ? classes.loading : undefined)}>{children}</div>
        </div>
    );
};
export default SpinnerOverlay;
